
<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.orange">
  <mat-card-content>
    <div style="color: #303030" class="flex flex-row justify-start items-center gap-2">
      <mat-icon class="medium-icon m-6">domain</mat-icon>
      <span class="f-s-20">{{title}} </span>
      <span class="flex-1"></span>
    </div>
  </mat-card-content>
</mat-card>

<div class="max-md:flex-col flex flex-row gap-4">
  <div [@slideRight] *ngIf="license.id === 0" class="flex flex-col gap-2 w-[100%]">
    <div class="max-md:flex-col flex flex-row justify-start items-center gap-2">
      <form [formGroup]="searchForm" *ngIf="showSearch" class="w-[80%]">
        <div class="flex flex-wrap md:flex-row flex-col justify-start items-center gap-2">
          <div class="max-lg:flex-col lg:flex-nowrap flex flex-row flex-wrap gap-2 w-full lg:w-auto">
            <mat-form-field class="w-full lg:w-[170px]">
              <input matInput placeholder="Entity Name" formControlName="entityName">
            </mat-form-field>
            <mat-form-field class="w-full lg:w-[170px]">
              <input matInput placeholder="license Id" formControlName="licenseId">
            </mat-form-field>
            <mat-form-field class="w-full lg:w-[170px]">
              <mat-label>
                Assigned To
              </mat-label>
              <mat-select formControlName="assignedTo">
                <mat-option>All</mat-option>
                <mat-option *ngFor="let staff of licenseStaff" value={{staff.id}}>{{staff.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full lg:w-[170px]">
              <mat-label>
                Statuses
              </mat-label>
              <mat-select formControlName="statuses" multiple #select>
                <mat-checkbox [(ngModel)]="allSelected" style = "margin: 5px 17px;"
                [ngModelOptions]="{standalone: true}"
                (change)="toggleAllSelection()">Select All</mat-checkbox>
                <mat-option *ngFor="let status of sharedService.statusListServiceCenterManufacturerLaboratory" [value]="status" (click)="optionClick()">
                  {{status}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-wrap md:flex-row flex-col justify-start items-center gap-2">
          <div class="max-lg:flex-col lg:flex-nowrap flex flex-row flex-wrap gap-2 w-full lg:w-auto">
            <mat-form-field class="w-full lg:w-[170px]">
              <input matInput placeholder="Street" formControlName="street">
            </mat-form-field>

            <mat-form-field class="w-full lg:w-[170px]">
              <input matInput placeholder="City" formControlName="city">
            </mat-form-field>

            <mat-form-field class="w-full lg:w-[170px]">
              <mat-label>County</mat-label>
              <mat-select formControlName="county">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let county of sharedService.counties" value={{county}}>
                  {{county}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="max-lg:flex-col max-lg:justify-center max-lg:items-center flex flex-row justify-end items-center gap-2">
          <mat-checkbox formControlName="onlyPaid">
            Paid Application Fee
          </mat-checkbox>
          <button mat-stroked-button type="submit" color="primary" (click)="searchLicenses()"
            matTooltip="Search Licenses" matTooltipShowDelay=800 aria-label="Search Licenses">
            Search
          </button>
        </div>
      </form>
      <span class="flex-1"></span>
      <span (click)="createLicense()" class="f-s-16" style="cursor: pointer;" *ngIf="showAddNew && (authService.isAdmin || authService.isTestingLabAdmin)">Add License</span>
      <button type="button" mat-icon-button color="primary" matTooltip="Add license" matTooltipShowDelay=800
        *ngIf="showAddNew && (authService.isAdmin || authService.isTestingLabAdmin)" aria-label="Add license" (click)="createLicense()">
        <mat-icon>post_add</mat-icon>
      </button>
    </div>
    <div class="max-md:flex-col flex flex-row justify-start items-center gap-2">
      <span class="flex-1"></span>
      <span>Results: {{ licenseCount }}</span>
    </div>

    <div class="lg:hidden flex flex-col gap-4">
      <mat-card *ngFor="let license of licenseSource.data" class="cursor-pointer" (click)="getLicense(license.id)"
        [ngClass]="{'hasRenewal': license.hasRenewal, 'isRenewal': license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.expired && license.status != sharedService.approved}">
        <mat-card-content>
          <div class="flex flex-col gap-3">
            <div class="flex flex-row justify-between items-start">
              <div class="flex flex-col">
                <span class="font-bold text-lg">{{license.entityName}}</span>
                <span class="text-sm text-gray-600">{{license.licenseId}}</span>
                <span class="text-sm text-gray-500" *ngIf="license.street != '' || license.city != '' || license.county != ''">
                  <span *ngIf="license.street != ''">{{license.street}}, </span>
                  <span *ngIf="license.city != ''">{{license.city}} </span>
                  <span *ngIf="license.county != ''">{{license.county}} County</span>
                </span>
              </div>
              <div class="flex flex-row gap-2">
                <mat-icon style="color:red" *ngIf="hasRedFlag(license)">flag</mat-icon>
                <mat-icon style="color:blue" *ngIf="hasBlueFlag(license)">flag</mat-icon>
                <mat-icon style="color:rgb(229, 238, 65)" *ngIf="hasYellowFlag(license)">flag</mat-icon>
                <mat-icon *ngIf="hasBlueFlag(license) || hasYellowFlag(license) || authService.isAdmin" (click)="openManagerAlerts(license); $event.stopPropagation()">more_horiz</mat-icon>
              </div>
            </div>

            <div class="flex flex-col gap-1">
              <div class="flex flex-row gap-2">
                <span class="font-semibold min-w-[120px]">Status:</span>
                <span>{{license.status}}</span>
              </div>
              <div class="flex flex-row gap-2">
                <span class="font-semibold min-w-[120px]">Date Submitted:</span>
                <span>{{license.applicationDate | date}}</span>
              </div>
              <div class="flex flex-row gap-2" *ngIf="license.approvedDate !== null && license.approvedDate !== ''">
                <span class="font-semibold min-w-[120px]">Approved Date:</span>
                <span>{{license.approvedDate | date}}</span>
              </div>
              <div class="flex flex-row gap-2" *ngIf="license.expirationDate !== null && license.expirationDate !== ''">
                <span class="font-semibold min-w-[120px]">Expiration Date:</span>
                <span>{{license.expirationDate | date}}</span>
              </div>
              <div class="flex flex-row gap-2" *ngIf="license.tasks && license.tasks.length > 0">
                <span class="font-semibold min-w-[120px]">Tasks:</span>
                <div class="flex flex-col">
                  <span *ngFor="let task of license.tasks">
                    <span *ngIf="!task.complete && !task.archived">{{task.taskText}}</span>
                  </span>
                </div>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <div class="flex flex-row items-center gap-2" *ngIf="authService.isAdmin">
                <span class="font-semibold min-w-[150px]">Licensing Member:</span>
                <mat-form-field class="flex-1">
                  <mat-select [(value)]="license.assignedTo" (selectionChange)="assignLicense($event, license.id)" (click)="$event.stopPropagation()">
                    <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let staff of licenseStaff" value={{staff.name}}>{{staff.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="flex flex-row items-center gap-2" *ngIf="!authService.isAdmin && license.assignedTo">
                <span class="font-semibold min-w-[150px]">Licensing Member:</span>
                <span>{{license.assignedTo}}</span>
              </div>

              <div class="flex flex-row items-center gap-2" *ngIf="authService.isAdmin">
                <span class="font-semibold min-w-[150px]">Compliance Member:</span>
                <mat-form-field class="flex-1">
                  <mat-select [(value)]="license.assignedToCompliance" (selectionChange)="assignComplianceMember($event, license.id)" (click)="$event.stopPropagation()">
                    <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let staff of licenseStaff" value={{staff.name}}>{{staff.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="flex flex-row items-center gap-2" *ngIf="!authService.isAdmin && license.assignedToCompliance">
                <span class="font-semibold min-w-[150px]">Compliance Member:</span>
                <span>{{license.assignedToCompliance}}</span>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <button mat-button type="button" color="primary"
                *ngIf="sharedService.userNameClaim != license.assignedTo"
                (click)="claimLicense(license); $event.stopPropagation()">Claim &amp; Edit</button>
              <button mat-button type="button" color="error"
                *ngIf="authService.isAdmin && license.assignedTo != '' && license.assignedTo != null"
                (click)="releaseLicense(license.id, $event); $event.stopPropagation()">Release Team Member</button>
              <button mat-button type="button" color="error"
                *ngIf="authService.isAdmin && license.assignedToCompliance != '' && license.assignedToCompliance != null"
                (click)="releaseComplianceMember(license.id, $event); $event.stopPropagation()">Release Compliance Member</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-table [dataSource]="licenseSource" matSort aria-describedby="licenses" #licenseSort="matSort" class="mat-elevation-z8 m-b-0 max-lg:hidden">

      <ng-container matColumnDef="entityName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Operational Name</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-col gap-1">
            <div class="flex flex-row gap-1">
             <span>{{license.entityName}}</span>
            </div>
            <div class="flex flex-row gap-1">
              <span>
                <span *ngIf="license.street != ''">{{license.street}}, </span>
                <span *ngIf="license.city != ''">{{license.city}} </span>
                <span *ngIf="license.county != ''">{{license.county}} County</span>
              </span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="licenseId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>License Id</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-row gap-1">
            <span>{{license.licenseId}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tasks">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tasks</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-col">
            <span *ngFor="let task of license.tasks">
              <span *ngIf="!task.complete && !task.archived">{{task.taskText}}</span>
            </span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-row gap-2">
            <span>{{license.status}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="applicationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Date Submitted</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-row gap-2">
            <span>{{license.applicationDate | date}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="approvedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Approved Date</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-col">
            <div *ngIf="license.approvedDate !== null && license.approvedDate !== ''" class="flex flex-row gap-2">
              <span>{{license.approvedDate | date}}</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expirationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</mat-header-cell>
        <mat-cell *matCellDef="let license" (click)="getLicense(license.id)">
          <div class="flex flex-col">
            <div *ngIf="license.expirationDate !== null && license.expirationDate !== ''" class="flex flex-row gap-2">
              <span>{{license.expirationDate | date}}</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="assignedTo">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To Licensing Member</mat-header-cell>
        <mat-cell *matCellDef="let license">
          <mat-form-field style="margin-top: -1em; margin-bottom: -1.25em" *ngIf="authService.isAdmin">
            <mat-select [(value)]="license.assignedTo" (selectionChange)="assignLicense($event, license.id)">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let staff of licenseStaff" value={{staff.name}}>{{staff.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span *ngIf="!authService.isAdmin">{{license.assignedTo}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="assignedToCompliance">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To Compliance Member</mat-header-cell>
        <mat-cell *matCellDef="let license">
          <mat-form-field style="margin-top: -1em; margin-bottom: -1.25em" *ngIf="authService.isAdmin">
            <mat-select [(value)]="license.assignedToCompliance" (selectionChange)="assignComplianceMember($event, license.id)">
             <mat-option>-- None --</mat-option>
             <mat-option *ngFor="let staff of licenseStaff" value={{staff.name}}>{{staff.name}}
             </mat-option>
           </mat-select>
         </mat-form-field>
         <span *ngIf="!authService.isAdmin">{{license.assignedToCompliance}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">
        </mat-header-cell>
        <mat-cell *matCellDef="let license">
          <div class="flex flex-col gap-1">
            <button mat-button class="m-l-16" type="button" color="primary" [ngStyle]="{'line-height': '1.5', 'text-align': 'start'}"
            *ngIf="sharedService.userNameClaim != license.assignedTo" (click)="claimLicense(license)">Claim &amp;
            Edit</button>
            <button mat-button class="text-wrap" type="button" color="error" [ngStyle]="{'line-height': '1.5', 'text-align': 'start'}"
              *ngIf="authService.isAdmin && license.assignedTo != '' && license.assignedTo != null"
              (click)="releaseLicense(license.id, $event)">Release Team Member</button>
              <button mat-button class="text-wrap" type="button" color="error" [ngStyle]="{'line-height': '1.5', 'text-align': 'start'}"
              *ngIf="authService.isAdmin && license.assignedToCompliance != '' && license.assignedToCompliance != null"
              (click)="releaseComplianceMember(license.id, $event)">Release Compliance Member</button>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="managerFlag">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">
          Alerts
        </mat-header-cell>
        <mat-cell *matCellDef="let license">
          <div class="flex flex-row gap-3">
            <mat-icon style="color:red" *ngIf="hasRedFlag(license)">flag</mat-icon>
            <mat-icon style="color:blue" *ngIf="hasBlueFlag(license)">flag</mat-icon>
            <mat-icon style="color:rgb(229, 238, 65)" *ngIf="hasYellowFlag(license)">flag</mat-icon>
            <mat-icon *ngIf="hasBlueFlag(license) || hasYellowFlag(license) || authService.isAdmin" (click)="openManagerAlerts(license)" >more_horiz</mat-icon>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="licenseColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: licenseColumns" [ngClass]="{'hasRenewal': row.hasRenewal, 'isRenewal': row.isRenewal && !row.hasRenewal && !row.renewed && row.status != sharedService.expired && row.status != sharedService.approved}"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" #licensePaginator="matPaginator" [pageIndex]="currentPage" [pageSize]="pageSize">
    </mat-paginator>
  </div>
</div>

<mat-tab-group animationDuration="200ms" *ngIf="license.id !== 0" [selectedIndex]="selectedIndex" (selectedIndexChange)="changeStep($event)">
  <mat-tab label="Testing Lab Dashboard">
    <mat-card>
      <mat-card-content>
        <div class="max-md:flex-col flex flex-row w-[100%]">
          <div [ngClass]="showChecklist ? 'w-[75%]' : 'w-[100%]'" class="max-md:w-[100%]">
        <div class="flex flex-col">
          <!--License Information-->
          <form [formGroup]="licenseForm" *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut]>
            <div class="flex flex-col">
                <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor">
                  <mat-card-title>
                    <div class="flex flex-row justify-start items-center gap-4">
                      <span *ngIf="addingNewLicense">Add Testing Lab</span>
                      <span *ngIf="editingLicense && !addingNewLicense">Edit Testing Lab</span>
                      <span *ngIf="!addingNewLicense && !editingLicense">Testing Lab</span>
                      <span class="f-s-18">{{license.licenseId}}</span>
                      <button type="button" mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
                        matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <span class="flex-1"></span>
                      <span style="font-size: 18px;">{{licenseForm.get('status').value}} - </span>
                      <div style="font-size: 18px;" class="flex flex-col justify-start items-center gap-4">
                        <div *ngIf="expiredLicensesLoaded" class="flex flex-col">
                          <span >{{getRenewalNumber(license)}}</span>
                        </div>
                        <div *ngIf="sharedService.approvedStatuses.includes(licenseForm.get('status').value)" class="flex flex-col">
                          <span *ngIf="!license.isRenewal">Approved on - {{licenseForm.get('approvedDate').value | date}}</span>
                          <span *ngIf="license.isRenewal">Renewed on - {{licenseForm.get('approvedDate').value | date}}</span>
                          <span *ngIf="license.isRenewal">Date Renewal Approved - {{licenseForm.get('renewedDate').value | date}}</span>
                          <span>Expires on - {{license.expirationDate | date}}</span>
                        </div>

                      </div>
                      <div style="font-size: 18px;" *ngIf="sharedService.nonApprovedStatuses.includes(licenseForm.get('status').value)" class="flex flex-col justify-start items-center gap-4">
                        <span>Submitted on - {{license.applicationDate | date}}</span>
                      </div>
                      <span class="flex-1"></span>
                      <div class="flex flex-col">
                      <div class="max-md:flex-col max-md:justify-start max-md:items-center flex flex-row gap-2">
                        <mat-icon style="color:red" *ngIf="hasRedFlag(license)">flag</mat-icon>
                        <mat-icon style="color:blue" *ngIf="hasBlueFlag(license)">flag</mat-icon>
                        <mat-icon style="color:rgb(229, 238, 65)" *ngIf="hasYellowFlag(license)">flag</mat-icon>
                        <button mat-button type="button" color="warn" (click)="cancelWorkingLicense()">Cancel</button>
                        <button mat-button type="button" color="primary" *ngIf="(!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" (click)="updateLicense(false)" [hidden]="licenseLocked">Save</button>
                        <button mat-button type="button" color="primary" *ngIf="(!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" (click)="updateLicense(true)" [hidden]="licenseLocked">Save & Close</button>
                        <button *ngIf="!addingNewLicense && (!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" type="button" mat-icon-button [color]="editingLicense? 'primary':'warn'"
                          [matTooltip]="editingLicense? 'Stop Editing' : 'Edit Testing Lab'" matTooltipShowDelay=800
                          aria-label="Edit Testing Lab" (click)="editLicense()" [hidden]="licenseLocked">
                          <mat-icon>{{editingLicense? 'edit' : 'edit_off'}}</mat-icon>
                        </button>
                        <button *ngIf="licenseLocked && (authService.isAdmin || authService.isTestingLabAdmin)" type="button" mat-icon-button matTooltip="Unlock License" matTooltipShowDelay=800 color="primary"
                          aria-label="Unlock License" (click)="unlockLicense()">
                          <mat-icon>lock_open_right</mat-icon>
                        </button>
                      </div>
                      <div class="max-md:flex-col max-md:justify-start max-md:items-center flex flex-row gap-2">
                        <button *ngIf="licenseChecklist.id != 0 && licenseChecklist.id != null" type="button" mat-icon-button [color]="!showChecklist? 'primary':'warn'"
                          matTooltip="Toggle Checklist" matTooltipShowDelay=800 aria-label="Toggle Checklist" (click)="toggleChecklist()">
                          <mat-icon>checklist</mat-icon>
                        </button>
                        <button mat-button type="button" color="primary" *ngIf="licenseChecklist.id == 0 && (!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" (click)="createChecklist()" [hidden]="licenseLocked">Create Checklist</button>
                        <button mat-button type="button" color="primary"
                          *ngIf="license.status == 'Approved' || license.status == 'Renewed' || license.status == 'Revoked' || license.status == 'Expired'
                            || license.status == 'Surrendered' || license.status == 'Request Surrender'"
                          (click)="viewPrintScreen(license)">Print License</button>
                      </div>
                    </div>
                    </div>
                    <div class="flex flex-row justify-start items-center">
                      <span style="font-size: 20px;" *ngIf="license.locked"><strong>License Locked By: {{license.lockedUserName}}</strong></span>
                      <span class="f-s-18 m-b-8" *ngIf="license.enteredByStaff">Manually Entered</span>
                    </div>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="flex flex-row gap-4">
                      <mat-card class="w-[45%]">
                        <mat-card-title>
                          <span>Testing Lab Information</span>
                        </mat-card-title>
                        <mat-card-content *ngIf="!editingLicense">
                          <div class="flex flex-col gap-2">
                            <span class="f-s-16"><strong>Laboratory Operational Name</strong></span>
                            <span>{{license.entityName}}</span>

                            <span class="f-s-16" *ngIf="sharedService.isAfterJan15th2027()"><strong>Is this operational name registered as an Assumed Business Name with the Secretary of State in Oregon?</strong></span>
                            <span *ngIf="sharedService.isAfterJan15th2027()">{{license.assumedBusiness ? 'Yes' : 'No'}}</span>

                            <span class="f-s-16" *ngIf="sharedService.isAfterJan15th2027() && license.assumedBusiness"><strong>Oregon Secretary of State ABN Number</strong></span>
                            <span *ngIf="sharedService.isAfterJan15th2027() && license.assumedBusiness">{{license.assumedBusinessNumber}}</span>

                            <span class="f-s-16"><strong>Previous Laboratory Operational Names</strong></span>
                            <span *ngIf="license.previousLicenseNames.length < 1">None</span>
                            <span *ngFor="let name of license.previousLicenseNames">{{name}}</span>

                            <span class="f-s-16"><strong>Testing Lab Website</strong></span>
                            <span [ngClass]="{'updated-field': isFieldUpdated('EntityWebsite', 'TestingLabLicenses', license.id.toString())}">{{license.entityWebsite}}</span>

                            <span class="f-s-16"><strong>Registered Business</strong></span>
                            <div class="flex flex-row">
                              <mat-checkbox [checked]="license.businessInOregon" disabled>
                                <span class="text-wrap">This legal entity is registered as a business with the Secretary of State (SOS) in Oregon</span>
                              </mat-checkbox>
                            </div>
                            <div *ngIf="license.businessInOregon" [@slideInOut] class="flex flex-col gap-2">
                              <div class="flex flex-col">
                                <span>Oregon Secretary of State Registry Number</span>
                                <span>{{license.secretaryofStateNumber}}</span>
                              </div>
                            </div>

                            <div class="flex flex-row">
                              <mat-checkbox [checked]="license.registeredBusiness" disabled>
                                <span class="text-wrap">This legal entity is registered as a business in another state, US territory or a freely associated state</span>
                              </mat-checkbox>
                            </div>
                            <div *ngIf="license.registeredBusiness" [@slideInOut] class="flex flex-col gap-2">
                              <div class="flex flex-col">
                                <span>Location Registered</span>
                                <span>{{license.registeredIn}}</span>
                              </div>
                              <div class="flex flex-col">
                                <span>Registration Number</span>
                                <span>{{license.registryNumber}}</span>
                              </div>
                            </div>

                            <span class="f-s-16"><strong>Other OPS Licenses or Permits</strong></span>
                            <mat-checkbox [checked]="license.previousLicense" disabled [ngClass]="{'updated-field': isFieldUpdated('PreviousLicense', 'TestingLabLicenses', license.id.toString())}">
                              <span class="text-wrap">Has the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services?</span>
                            </mat-checkbox>
                            <div *ngIf="this.licenseForm.get('previousLicense').value" [@slideInOut] class="flex flex-col">
                              <span [ngClass]="{'updated-field': isFieldUpdated('AffiliatedLicenses', 'TestingLabLicenses', license.id.toString())}">{{license.affiliatedLicenses}}</span>
                            </div>
                            <span class="f-s-16"><strong>Inspection Last Completed</strong></span>
                            <span>{{license.inspectionCompletedDate | date}}</span>
                            <span class="f-s-16" *ngIf="!license.isRenewal"><strong>Approved Date</strong></span>
                            <span class="f-s-16" *ngIf="license.isRenewal"><strong>Renewed Date</strong></span>
                            <span>{{license.approvedDate | date}}</span>
                            <span class="f-s-16"><strong>Expiration Date</strong></span>
                            <span>{{license.expirationDate | date}}</span>
                            <div *ngIf="license.isRenewal" class="flex flex-row gap-2">
                              <div class="flex flex-col gap-2">
                                <span *ngIf="licenseForm.get('applicantsCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('ApplicantsCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant attests the applicants listed are their current applicants</strong></span>
                                <span *ngIf="!licenseForm.get('applicantsCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('ApplicantsCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant does not attest the applicants listed are their current applicants</strong></span>
                                <textarea *ngIf="!licenseForm.get('applicantsCorrect').value" matInput placeholder="Applicant Changes" cols="2" [value]="license.applicantsCorrectReason" [readonly]="true" [ngClass]="{'updated-field': isFieldUpdated('ApplicantsCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                              </div>
                            </div>
                            <div *ngIf="license.isRenewal" class="flex flex-row gap-2">
                              <div class="flex flex-col gap-2">
                                <span *ngIf="licenseForm.get('financialInterestCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('FinancialInterestCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant attests financial interest statements to be current and correct</strong></span>
                                <span *ngIf="!licenseForm.get('financialInterestCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('FinancialInterestCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant does not attest financial interest statements to be current and correct</strong></span>
                                <textarea *ngIf="!licenseForm.get('financialInterestCorrect').value" matInput placeholder="Financial Changes" cols="2" [value]="license.financialInterestCorrectReason" [readonly]="true" [ngClass]="{'updated-field': isFieldUpdated('FinancialInterestCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                              </div>
                            </div>
                            <div *ngIf="license.isRenewal" class="flex flex-row gap-2">
                              <div class="flex flex-col gap-2">
                                <span *ngIf="licenseForm.get('testingLabInformationCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('TestingLabInformationCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant attests Testing Lab information to be current and correct</strong></span>
                                <span *ngIf="!licenseForm.get('testingLabInformationCorrect').value"><strong [ngClass]="{'updated-field': isFieldUpdated('TestingLabInformationCorrect', 'TestingLabLicenses', license.id.toString())}">Applicant does not attest Testing Lab information to be current and correct</strong></span>
                                <textarea *ngIf="!licenseForm.get('testingLabInformationCorrect').value" matInput placeholder="Lab Changes" cols="2" [value]="license.testingLabInformationCorrectReason" [readonly]="true" [ngClass]="{'updated-field': isFieldUpdated('TestingLabInformationCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                              </div>
                            </div>
                          </div>
                        </mat-card-content>

                        <mat-card-content *ngIf="editingLicense">
                          <div class="flex flex-col gap-2">
                            <span class="f-s-16"><strong>Laboratory Operational Name</strong></span>
                            <mat-form-field>
                              <input matInput placeholder="Name" formControlName="entityName">
                              <mat-error *ngIf="licenseForm.get('entityName').invalid">
                                A Testing Lab name is required
                              </mat-error>
                            </mat-form-field>

                            <span class="f-s-16" *ngIf="sharedService.isAfterJan15th2027()"><strong>Assumed Business Name</strong></span>
                            <div class="flex flex-row gap-2 f-s-16" *ngIf="sharedService.isAfterJan15th2027()">
                              <div class="flex flex-col">
                                <span id="assumedBusiness" class="text-wrap">Is this operational name registered as an Assumed Business Name with the Secretary of State in Oregon?</span>
                                <mat-radio-group aria-label="Select an option" formControlName="assumedBusiness" aria-describedby="assumedBusiness" class="gap-2">
                                  <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                                  <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                                </mat-radio-group>
                              </div>
                            </div>
                            <div *ngIf="licenseForm.get('assumedBusiness').value == true && sharedService.isAfterJan15th2027()" [@slideInOut] class="flex flex-col gap-2 f-s-16">
                              <div class="flex flex-col">
                                <span id="assumedBusinessNumber">Oregon Secretary of State ABN Number</span>
                                <mat-form-field>
                                  <input matInput placeholder="Oregon Secretary of State ABN Number" formControlName="assumedBusinessNumber" aria-describedby="assumedBusinessNumber">
                                </mat-form-field>
                              </div>
                            </div>

                            <span class="f-s-16"><strong>Testing Lab Website</strong></span>
                            <mat-form-field>
                              <input matInput placeholder="Website" formControlName="entityWebsite" [ngClass]="{'updated-field': isFieldUpdated('EntityWebsite', 'TestingLabLicenses', license.id.toString())}">
                              <mat-error *ngIf="licenseForm.get('entityWebsite').hasError('pattern')">
                                Please enter a valid URL (http:// or https://)
                              </mat-error>
                            </mat-form-field>

                            <span class="f-s-16"><strong>Registered Business</strong></span>
                            <div class="flex flex-row">
                              <mat-checkbox formControlName="businessInOregon">
                                <span class="text-wrap">This legal entity is registered as a business with the Secretary of State (SOS) in Oregon</span>
                              </mat-checkbox>
                            </div>
                            <div *ngIf="licenseForm.get('businessInOregon').value" [@slideInOut] class="flex flex-col gap-2">
                              <div class="flex flex-col">
                                <span>Oregon Secretary of State Registry Number</span>
                                <mat-form-field>
                                  <input matInput placeholder="Secretary of State Number" formControlName="secretaryofStateNumber">
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="flex flex-row">
                              <mat-checkbox formControlName="registeredBusiness">
                                <span class="text-wrap">This legal entity is registered as a business in another state, US territory or a freely associated state</span>
                              </mat-checkbox>
                            </div>
                            <div *ngIf="licenseForm.get('registeredBusiness').value" [@slideInOut] class="flex flex-col gap-2">
                              <div class="flex flex-col">
                                <span>Location Registered</span>
                                <mat-form-field>
                                  <input matInput placeholder="Location Registered" formControlName="registeredIn">
                                </mat-form-field>
                                <span>Registration Number</span>
                                <mat-form-field>
                                  <input matInput placeholder="Registration Number" formControlName="registryNumber">
                                </mat-form-field>
                              </div>
                            </div>

                            <span class="f-s-16"><strong>Other OPS Licenses or Permits</strong></span>
                            <mat-checkbox formControlName="previousLicense" [ngClass]="{'updated-field': isFieldUpdated('PreviousLicense', 'TestingLabLicenses', license.id.toString())}">
                              <span class="text-wrap">Has the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services?</span>
                            </mat-checkbox>
                            <div *ngIf="this.licenseForm.get('previousLicense').value" [@slideInOut] class="flex flex-col">
                              <span>Please provide the license numbers for each Oregon Psilocybin license</span>
                              <mat-form-field>
                                <input matInput placeholder="Affiliated Licenses" formControlName="affiliatedLicenses" [ngClass]="{'updated-field': isFieldUpdated('AffiliatedLicenses', 'TestingLabLicenses', license.id.toString())}"
                                  (blur)="validatePreviousLicense()">
                                <mat-error *ngIf="validatePreviousLicense()">
                                  Please provide all license numbers
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <span class="f-s-16"><strong>Inspection Last Completed</strong></span>
                            <mat-form-field>
                              <mat-label>Inspection Completed On</mat-label>
                              <input placeholder="mm/dd/yyyy" formControlName="inspectionCompletedDate" matInput [matDatepicker]="inspectionCompletedDate"
                                [max]="today" />
                              <mat-datepicker-toggle matSuffix [for]="inspectionCompletedDate"></mat-datepicker-toggle>
                              <mat-datepicker #inspectionCompletedDate>
                                <mat-datepicker-actions>
                                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                                  <button mat-button matDatepickerCancel>Cancel</button>
                                </mat-datepicker-actions>
                              </mat-datepicker>
                              <mat-error *ngIf="licenseForm.get('inspectionCompletedDate').value > today">
                                Please choose an earlier date.
                              </mat-error>
                            </mat-form-field>
                            <span class="f-s-16" *ngIf="!license.isRenewal"><strong>Approved Date</strong></span>
                            <span class="f-s-16" *ngIf="license.isRenewal"><strong>Renewed Date</strong></span>
                            <span>{{license.approvedDate | date}}</span>
                            <span class="f-s-16"><strong>Expiration Date</strong></span>
                            <span>{{license.expirationDate | date}}</span>
                            <mat-checkbox formControlName="applicantsCorrect" *ngIf="license.isRenewal" [ngClass]="{'updated-field': isFieldUpdated('ApplicantsCorrect', 'TestingLabLicenses', license.id.toString())}">
                              Applicant attests the applicants listed are their current applicants
                            </mat-checkbox>
                            <span *ngIf="!licenseForm.get('applicantsCorrect').value && license.isRenewal">Changes</span>
                            <textarea *ngIf="!licenseForm.get('applicantsCorrect').value && license.isRenewal" matInput placeholder="Applicant changes" cols="2" formControlName="applicantsCorrectReason" [ngClass]="{'updated-field': isFieldUpdated('ApplicantsCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                            <mat-checkbox formControlName="financialInterestCorrect" *ngIf="license.isRenewal" [ngClass]="{'updated-field': isFieldUpdated('FinancialInterestCorrect', 'TestingLabLicenses', license.id.toString())}">
                              Applicant attests financial interest statements to be current and correct
                            </mat-checkbox>
                            <span *ngIf="!licenseForm.get('financialInterestCorrect').value && license.isRenewal">Changes</span>
                            <textarea *ngIf="!licenseForm.get('financialInterestCorrect').value && license.isRenewal" matInput placeholder="Financial changes" cols="2" formControlName="financialInterestCorrectReason" [ngClass]="{'updated-field': isFieldUpdated('FinancialInterestCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                            <mat-checkbox formControlName="testingLabInformationCorrect" *ngIf="license.isRenewal" [ngClass]="{'updated-field': isFieldUpdated('TestingLabInformationCorrect', 'TestingLabLicenses', license.id.toString())}">
                              Applicant attests Testing Lab information to be current and valid
                            </mat-checkbox>
                            <span *ngIf="!licenseForm.get('testingLabInformationCorrect').value && license.isRenewal">Changes</span>
                            <textarea *ngIf="!licenseForm.get('testingLabInformationCorrect').value && license.isRenewal" matInput placeholder="Lab changes" cols="2" formControlName="testingLabInformationCorrectReason" [ngClass]="{'updated-field': isFieldUpdated('TestingLabInformationCorrectReason', 'TestingLabLicenses', license.id.toString())}"></textarea>
                          </div>
                        </mat-card-content>
                      </mat-card>

                      <div class="flex flex-col w-[35%]">
                        <mat-card>
                          <mat-card-title>
                            <span>Primary Point of Contact</span>
                          </mat-card-title>
                          <mat-card-content>
                            <div class="flex flex-col gap-4">

                              <div class="flex flex-col">
                                <span class="f-s-16"><strong>Contact Name</strong></span>
                                <span>{{license.primaryContactName}}</span>
                              </div>
                              <div class="flex flex-col">
                                <span class="f-s-16"><strong>Contact Phone</strong></span>
                                <span>{{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}</span>
                              </div>
                              <div class="flex flex-col">
                                <span class="f-s-16"><strong>Email Address</strong></span>
                                <span class="justify-start items-center gap-3">
                                  <span>{{license.primaryContactEmail}}</span>
                                  <span *ngIf="license.accountEmail != null && license.accountEmail.length > 0 && license.primaryContactEmail != ''">
                                    <a *ngIf="license.accountIsB2C" (click)="openAddMessageDialog(license.primaryContactName, license.accountEmail) ">
                                      <mat-icon>email</mat-icon>
                                    </a>
                                    <a *ngIf="!license.accountIsB2C" [href]="'mailto:' + license.accountEmail" >
                                      <mat-icon>email</mat-icon>
                                    </a>
                                  </span>
                                </span>
                              </div>
                              <div class="flex flex-col">
                                <span class="f-s-16"><strong>Preferred Language</strong></span>
                                <span>{{license.language}}</span>
                              </div>

                            </div>
                          </mat-card-content>
                        </mat-card>

                        <mat-card *ngIf="license.previousPointsOfContact.length > 0">
                          <mat-card-title>
                            <span>Previous Points of Contact</span>
                          </mat-card-title>
                          <mat-card-content>
                            <div class="flex flex-col gap-4">
                              <div class="flex flex-col">
                                <span class="f-s-16"><strong>Contact Name</strong></span>
                                <span *ngFor="let name of license.previousPointsOfContact">{{name}}</span>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>

                        <mat-card>
                          <mat-card-title>
                            <span>Account Information</span>
                          </mat-card-title>
                          <mat-card-content>
                            <div class="m-t-8 flex flex-col gap-2">
                              <div>
                                <button *ngIf="license.accountName === null || license.accountName.length <= 0"
                                        type="button" color="primary" mat-flat-button (click)="addUserAccount()" [hidden]="licenseLocked">Add User</button>
                              </div>

                              <span>{{license.accountName}} </span>

                              <div class="flex flex-row justify-start items-center gap-2">
                                <span *ngIf="license.accountEmail != null && license.accountEmail.length > 0">
                                  {{license.accountEmail}}
                                </span>

                                <span *ngIf="license.accountEmail != null && license.accountEmail.length > 0 && (license.primaryContactEmail == null || license.primaryContactEmail == '')">
                                  <a *ngIf="license.accountIsB2C" (click)="openAddMessageDialog(license.accountName, license.accountEmail) ">
                                    <mat-icon>email</mat-icon>
                                  </a>
                                  <a *ngIf="!license.accountIsB2C" [href]="'mailto:' + license.accountEmail" >
                                    <mat-icon>email</mat-icon>
                                  </a>
                                </span>

                                <button *ngIf="!license.accountIsB2C && license.accountName?.length > 0"
                                  type="button" color="primary" mat-button (click)="editUserAccount()">Edit User</button>
                              </div>
                              </div>
                              <br />
                              <mat-card-title>
                                <span>Attorney Information</span>
                              </mat-card-title>
                              <div class="m-t-8 flex flex-row justify-start items-center gap-4" *ngIf="!editingLicense">
                                <div class="flex flex-col gap-2">
                                  <div class="f-s-16 m-b-8 flex flex-row">
                                    <span *ngIf="license.attorneyContact"><b>Attorney should be contacted instead of licensee</b></span>
                                    <span *ngIf="!license.attorneyContact">Attorney should <b>not</b> be contacted instead of licensee</span>
                                  </div>
                                  <div class="f-s-16 m-b-8 flex flex-row">
                                    <span *ngIf="license.attorneyConsent">Attorney consent document received</span>
                                    <span *ngIf="!license.attorneyConsent">Attorney consent document <b>not yet</b> received</span>
                                  </div>
                                  <div class="flex flex-row gap-4">
                                    <div class="flex flex-col">
                                      <span><b>Name</b></span>
                                      <span>{{license.attorneyName}}</span>
                                    </div>
                                    <div class="flex flex-col">
                                      <span><b>Phone Number</b></span>
                                      <span>{{license.attorneyPhone | mask: '(000) 000-0000 000000'}}</span>
                                    </div>
                                    <div class="flex flex-col">
                                      <span><b>Email</b></span>
                                      <span>{{license.attorneyEmail}}</span>
                                    </div>
                                  </div>
                                  <div class="flex flex-col">
                                    <span><b>Attorney's communication preference and procedure</b></span>
                                    <span class="text-wrap w-[100%]">{{license.attorneyNotes}}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="m-t-8 flex flex-row justify-start items-center gap-4" *ngIf="editingLicense">
                                <div class="flex flex-col w-[100%]">
                                  <div class="max-lg:flex-col flex flex-row gap-2">
                                    <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                                      <span class="f-2-20"><strong>Attorney Name</strong></span>
                                      <mat-form-field>
                                        <input matInput placeholder="Attorney Name" formControlName="attorneyName">
                                      </mat-form-field>
                                    </div>
                                    <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                                      <span class="f-2-20"><strong>Attorney Phone</strong></span>
                                      <mat-form-field>
                                        <input matInput placeholder="Attorney Phone" formControlName="attorneyPhone" mask="(000) 000-0000 000000" [validation]="false">
                                        <mat-error *ngIf="licenseForm.get('attorneyPhone').hasError('pattern')">
                                          Phone should match this format: 999-999-9999 x1234
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                  </div>

                                  <div class="max-lg:flex-col flex flex-row gap-2">
                                    <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                                      <span class="f-2-20"><strong>Attorney Email</strong></span>
                                      <mat-form-field>
                                        <input matInput placeholder="Attorney Email" formControlName="attorneyEmail">
                                        <mat-error *ngIf="licenseForm.get('attorneyEmail').hasError('email')">
                                          This doesn't look like a valid email address
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                    <div class="max-lg:w-[100%] flex flex-col gap-2 w-[50%]">
                                      <mat-checkbox formControlName="attorneyContact">
                                        <span class="text-wrap">Attorney should be contacted instead of licensee</span>
                                      </mat-checkbox>
                                      <mat-checkbox formControlName="attorneyConsent">
                                        <span class="text-wrap">Attorney consent document received</span>
                                      </mat-checkbox>
                                    </div>
                                  </div>

                                  <div class="max-lg:flex-col flex flex-row gap-2">
                                    <div class="max-lg:w-[100%] flex flex-col w-[100%]">
                                      <span class="f-2-20"><strong>Attorney's communication preference and procedure</strong></span>
                                      <span><i>(Use this section only to record Attorney's communication preference and procedure. Continue to keep all other notes in "Notes" section of profile.)</i></span>
                                      <mat-form-field>
                                        <textarea matInput placeholder="Attorney's communication preference and procedure" formControlName="attorneyNotes"></textarea>
                                      </mat-form-field>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>

                      <mat-card class="w-[25%]">
                        <mat-card-title>
                          <span>Attestations</span>
                        </mat-card-title>
                        <mat-card-content *ngIf="!editingLicense">
                          <div class="flex flex-col gap-2">
                            <span class="f-s-16">
                              <strong>Endorsements requested</strong>
                            </span>


                            <span class="f-s-16">
                              <strong>Financial Interest</strong>
                            </span>
                            <mat-checkbox [checked]="license.financialAttestation" disabled>
                              <span class="text-wrap">Applicant attests to all financial stuff</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>License Attestation</strong>
                            </span>
                            <mat-checkbox [checked]="license.attestation" disabled>
                              <span class="text-wrap">Applicant attests to everything</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>Registration Attestation</strong>
                            </span>
                            <mat-checkbox [checked]="license.registrationAttestation" disabled>
                              <span class="text-wrap">Applicant attests to registration requirements</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>Directory Consent</strong>
                            </span>
                            <mat-checkbox [checked]="license.directoryConsent" disabled>
                              <span class="text-wrap">
                                Applicant consents to having license in the OPS License Directory
                              </span>
                            </mat-checkbox>
                            <mat-checkbox *ngIf="license.directoryConsent" [checked]="license.directoryConsentWebsite" disabled>
                              <span class="text-wrap">
                                Applicant consents to have their website displayed in the OPS License Directory: <strong style="word-break: break-word;">{{license.directoryWebsite}}</strong>
                              </span>
                            </mat-checkbox>
                            <mat-checkbox *ngIf="license.directoryConsent" [checked]="license.directoryConsentEmail" disabled>
                              <span class="text-wrap">
                                Applicant consents to have their email displayed in the OPS License Directory: <strong style="word-break: break-word;">{{license.directoryEmail}}</strong>
                              </span>
                            </mat-checkbox>
                            <mat-checkbox *ngIf="license.directoryConsent" [checked]="license.directoryConsentPhone" disabled>
                              <span class="text-wrap">
                                Applicant consents to have their phone number displayed in the OPS License Directory: <strong>{{license.directoryPhone | mask: '(000) 000-0000 000000' }}</strong>
                              </span>
                            </mat-checkbox>
                          </div>
                        </mat-card-content>

                        <mat-card-content *ngIf="editingLicense">
                          <div class="flex flex-col gap-2">
                            <span class="f-s-16">
                              <strong>Endorsements requested</strong>
                            </span>

                            <span class="f-s-16">
                              <strong>Financial Interest</strong>
                            </span>
                            <mat-checkbox formControlName="financialAttestation" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                              <span class="text-wrap">Applicant attests to all financial stuff</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>License Attestation</strong>
                            </span>
                            <mat-checkbox formControlName="attestation" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                              <span class="text-wrap">Applicant attests to everything</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>Registration Attestation</strong>
                            </span>
                            <mat-checkbox formControlName="registrationAttestation" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                              <span class="text-wrap">Applicant attests to registration requirements</span>
                            </mat-checkbox>

                            <span class="f-s-16">
                              <strong>Directory Consent</strong>
                            </span>
                            <mat-checkbox formControlName="directoryConsent" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                              <span class="text-wrap">
                                Applicant consents to having license in the OPS License Directory
                              </span>
                            </mat-checkbox>
                            <div class="gap-[10px] flex flex-row">
                              <mat-checkbox formControlName="directoryConsentWebsite" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                                <span class="text-wrap">
                                  Applicant consents to have their website displayed in the OPS License Directory:
                                </span>
                              </mat-checkbox>
                            </div>
                            <div class="gap-[10px] flex flex-row">
                              <mat-form-field>
                                <input matInput placeholder="Website" formControlName="directoryWebsite">
                              </mat-form-field>
                            </div>
                            <div class="gap-[10px] flex flex-row">
                              <mat-checkbox formControlName="directoryConsentEmail" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                                <span class="text-wrap">
                                  Applicant consents to have their email displayed in the OPS License Directory:
                                </span>
                              </mat-checkbox>
                            </div>
                            <div class="gap-[10px] flex flex-row">
                              <mat-form-field>
                                <input matInput placeholder="Email" formControlName="directoryEmail">
                              </mat-form-field>
                            </div>
                            <div class="gap-[10px] flex flex-row">
                              <mat-checkbox formControlName="directoryConsentPhone" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                                <span class="text-wrap">
                                  Applicant consents to have their phone number displayed in the OPS License Directory:
                                </span>
                              </mat-checkbox>
                            </div>
                            <div class="gap-[10px] flex flex-row">
                              <mat-form-field>
                                <input matInput placeholder="Phone" formControlName="directoryPhone" mask="(000) 000-0000 000000" >
                              </mat-form-field>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </mat-card-content>
                </mat-card>

                <div class="flex flex-row gap-2">
                  <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" [ngClass]="editingLicense ? 'w-[100%]' : 'w-[50%]'">
                    <mat-card-title>
                      <span>Testing Lab Address</span>
                    </mat-card-title>
                    <mat-card-content>
                      <mat-card>
                        <mat-card-content *ngIf="!editingLicense">
                          <div class="flex flex-col gap-4">
                            <span class="f-s-18"><strong>Physical Address</strong></span>
                            <div class="max-md:flex-col flex flex-row gap-2">
                              <span>{{license.physicalStreet}}</span>
                              <span>{{license.physicalCity}}</span>
                              <span>{{license.physicalState}}</span>
                              <span>{{license.physicalZip}}</span>
                              <span>{{license.physicalCounty}}</span>
                            </div>

                            <div class="flex flex-col">
                              <span><strong>Description of the premises</strong></span>
                              <div>
                                <textarea matInput placeholder="Describe the Premises" [value]="license.premisesDescription"></textarea>
                              </div>
                            </div>
                          </div>

                          <div class="m-t-8 flex flex-col">
                            <div class="max-md:flex-col flex flex-row gap-6">
                              <span class="f-s-18"><strong>Mailing Address</strong></span>
                              <mat-checkbox [checked]="license.mailingIsPhysical" disabled [ngClass]="{'updated-field': isFieldUpdated('MailingIsPhysical', 'TestingLabLicenses', license.id.toString())}">
                                Same as Physical
                              </mat-checkbox>
                            </div>
                            <div *ngIf="!license.mailingIsPhysical" class="max-md:flex-col flex flex-row gap-2">
                              <span [ngClass]="{'updated-field': isFieldUpdated('MailingStreet', 'TestingLabLicenses', license.id.toString())}">{{license.mailingStreet}}</span>
                              <span [ngClass]="{'updated-field': isFieldUpdated('MailingCity', 'TestingLabLicenses', license.id.toString())}">{{license.mailingCity}}</span>
                              <span [ngClass]="{'updated-field': isFieldUpdated('MailingState', 'TestingLabLicenses', license.id.toString())}">{{license.mailingState}}</span>
                              <span [ngClass]="{'updated-field': isFieldUpdated('MailingZip', 'TestingLabLicenses', license.id.toString())}">{{license.mailingZip}}</span>
                              <span [ngClass]="{'updated-field': isFieldUpdated('MailingCounty', 'TestingLabLicenses', license.id.toString())}">{{license.mailingCounty}}</span>
                            </div>
                          </div>
                        </mat-card-content>

                        <mat-card-content *ngIf="editingLicense">
                          <div class="flex flex-col">
                            <span class="f-s-18"><strong>Physical Address</strong></span>
                            <div class="max-md:flex-col flex flex-row gap-4">
                              <mat-form-field class="max-md:w-[100%] w-[30%]">
                                <mat-label>Street</mat-label>
                                <input matInput placeholder="Street Apt/Unit/Suite" formControlName="physicalStreet">
                                <mat-error *ngIf="licenseForm.get('physicalStreet').invalid">
                                  Please provide a street
                                </mat-error>
                              </mat-form-field>

                              <mat-form-field class="max-md:w-[100%] w-[30%]">
                                <mat-label>City</mat-label>
                                <input matInput placeholder="City" formControlName="physicalCity">
                                <mat-error *ngIf="licenseForm.get('physicalCity').invalid">
                                  Please provide a city
                                </mat-error>
                              </mat-form-field>

                              <mat-form-field class="max-md:w-[100%] w-[40%]">
                                <mat-label>State/US territory/freely associated state</mat-label>
                                <mat-select formControlName="physicalState">
                                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="licenseForm.get('physicalState').invalid">
                                  Please select a state
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="max-md:flex-col flex flex-row gap-4">
                              <mat-form-field class="max-md:w-[100%] w-[20%]">
                                <mat-label>Zip</mat-label>
                                <input matInput placeholder="Zip" formControlName="physicalZip">
                                <mat-error *ngIf="licenseForm.get('physicalZip').hasError('required')">
                                  Please provide a zipcode
                                </mat-error>
                                <mat-error *ngIf="licenseForm.get('physicalZip').hasError('pattern')">
                                  Zipcode should match this format: 99999 or 99999-1234
                                </mat-error>
                              </mat-form-field>

                              <mat-form-field *ngIf="licenseForm.get('physicalState').value === 'OR'" class="max-md:w-[100%] w-[20%]">
                                <mat-label>County</mat-label>
                                <mat-select formControlName="physicalCounty">
                                  <mat-option>-- None --</mat-option>
                                  <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <span>Please provide a brief description of the premises</span>
                            <div>
                              <mat-form-field class="w-[75%]">
                                <textarea matInput placeholder="Describe the Premises" cols="2" formControlName="premisesDescription"></textarea>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="m-t-8 flex flex-col">
                            <div class="max-md:flex-col flex items-center flex-row gap-6">
                              <span class="f-s-18"><strong>Mailing Address</strong></span>
                              <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()" [ngClass]="{'updated-field': isFieldUpdated('MailingIsPhysical', 'TestingLabLicenses', license.id.toString())}">
                                Same as Physical
                              </mat-checkbox>
                            </div>
                            <div [@slideInOut] *ngIf="!licenseForm.get('mailingIsPhysical').value" class="flex flex-col">
                              <div class="max-md:flex-col flex flex-row gap-4">
                                <mat-form-field class="max-md:w-[100%] w-[30%]">
                                  <mat-label>Street</mat-label>
                                  <input matInput placeholder="Street Apt/Unit/Suite" formControlName="mailingStreet" [ngClass]="{'updated-field': isFieldUpdated('MailingStreet', 'TestingLabLicenses', license.id.toString())}"
                                    (blur)="validateMailingStreet()">
                                  <mat-error *ngIf="validateMailingStreet()">
                                    Please provide a street
                                  </mat-error>
                                </mat-form-field>

                                <mat-form-field class="max-md:w-[100%] w-[30%]">
                                  <mat-label>City</mat-label>
                                  <input matInput placeholder="City" formControlName="mailingCity" (blur)="validateMailingCity()" [ngClass]="{'updated-field': isFieldUpdated('MailingCity', 'TestingLabLicenses', license.id.toString())}">
                                  <mat-error *ngIf="validateMailingCity()">
                                    Please provide a city
                                  </mat-error>
                                </mat-form-field>

                                <mat-form-field class="max-md:w-[100%] w-[40%]">
                                  <mat-label>State/US territory/freely associated state</mat-label>
                                  <mat-select formControlName="mailingState" (blur)="validateMailingState()" [ngClass]="{'updated-field': isFieldUpdated('MailingState', 'TestingLabLicenses', license.id.toString())}">
                                    <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                                  </mat-select>
                                  <mat-error *ngIf="validateMailingState()">
                                    Please provide a state
                                  </mat-error>
                                </mat-form-field>
                              </div>

                              <div class="max-md:flex-col flex flex-row gap-4">
                                <mat-form-field class="max-md:w-[100%] w-[20%]">
                                  <mat-label>Zip</mat-label>
                                  <input matInput placeholder="Zip" formControlName="mailingZip" (blur)="validateMailingZip()" [ngClass]="{'updated-field': isFieldUpdated('MailingZip', 'TestingLabLicenses', license.id.toString())}">
                                  <mat-error *ngIf="validateMailingZip()">
                                    Please provide a zipcode
                                  </mat-error>
                                  <mat-error *ngIf="licenseForm.get('mailingZip').hasError('pattern')">
                                    Zipcode should match this format: 99999 or 99999-1234
                                  </mat-error>
                                </mat-form-field>

                                <mat-form-field *ngIf="licenseForm.get('mailingState').value === 'OR'" class="max-md:w-[100%] w-[20%]">
                                  <mat-label>County</mat-label>
                                  <mat-select formControlName="mailingCounty" [ngClass]="{'updated-field': isFieldUpdated('MailingCounty', 'TestingLabLicenses', license.id.toString())}">
                                    <mat-option>-- None --</mat-option>
                                    <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </mat-card-content>
                  </mat-card>

                  <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" *ngIf="!editingLicense" class="max-lg:w-[100%] w-[50%]">
                    <mat-card-title>
                      <span>Current Documents</span>
                    </mat-card-title>
                    <mat-card-content class="flex flex-col gap-2">
                      <mat-card>
                        <mat-card-content>
                          <div class="flex flex-col">
                            <div *ngIf="!sharedService.mobile" class="flex flex-row">
                              <span class="f-s-16 w-[35%]"><strong>File</strong></span>
                              <span class="f-s-16 w-[25%]"><strong>Requirement</strong></span>
                              <span class="f-s-16 w-[20%]"><strong>Date Uploaded</strong></span>
                            </div>
                            <div *ngFor="let document of this.license.licenseDocuments"  class="max-md:flex-col flex flex-row justify-start items-start">
                              <ng-container *ngIf="!document.deprecated">
                                <span class="text-indigo-A700 w-[35%]" style="cursor: pointer; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="document.name" matTooltipShowDelay="500" (click)="downloadDocument(document.id, document.name)">{{document.name}}</span>

                                <div class="flex flex-col w-[25%]">
                                  <span *ngFor="let type of document.types">
                                    {{documentTypeReference[type]}}
                                  </span>
                                </div>
                                <span class="w-[20%]">{{document.dateCreated | date}}</span>
                              </ng-container>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>

                      <div class="flex flex-row">
                        <button type="button" color="primary" mat-flat-button (click)="viewArchivedDocuments()">
                          <span *ngIf="!viewArchived">
                            View Archived Documents
                          </span>
                          <span *ngIf="viewArchived">
                            Hide Archived Documents
                          </span>
                        </button>
                      </div>

                      <mat-card-title *ngIf="viewArchived">
                        <span>Archived Documents</span>
                      </mat-card-title>
                      <mat-card *ngIf="viewArchived" [style.background]="'#c7cdd1'">
                        <mat-card-content>
                          <div class="flex flex-col">
                            <div *ngIf="!sharedService.mobile" class="flex flex-row">
                              <span class="f-s-16 w-[35%]"><strong>File</strong></span>
                              <span class="f-s-16 w-[25%]"><strong>Requirement</strong></span>
                              <span class="f-s-16 w-[20%]"><strong>Date Uploaded</strong></span>
                            </div>
                            <div *ngFor="let document of this.license.licenseDocuments" style="justify-content: center;" class="max-md:flex-col flex flex-row justify-start items-center">
                              <ng-container *ngIf="document.deprecated">
                                <span class="text-indigo-A700 max-lg:w-[40%] w-[35%]" style="cursor: pointer; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="document.name" matTooltipShowDelay="500" (click)="downloadDocument(document.id, document.name)">{{document.name}}</span>

                                <div class="flex flex-col w-[25%]">
                                  <span *ngFor="let type of document.types">
                                    {{documentTypeReference[type]}}
                                  </span>
                                </div>

                                <span class="w-[20%]">{{document.dateCreated | date}}</span>
                              </ng-container>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </mat-card-content>
                  </mat-card>
                </div>
            </div>
          </form>

          <!--Documents-->
          <form [formGroup]="documentsForm" *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut]>
            <div *ngIf="editingLicense" class="max-md:flex-col flex flex-row gap-4 w-[100%]">
              <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[50%]">
                <mat-card-title>
                  Upload Supporting Documents
                </mat-card-title>
                <mat-card-content>
                  <mat-card>
                    <mat-card-content>
                      <div class="flex flex-col gap-2">
                        <span class="f-2-14">For each document select the requirements it verifies</span>
                        <div class="p-t-8 flex flex-col gap-2">
                          <div class="flex flex-col">

                            <mat-checkbox formControlName="orelap">
                              <span class="text-wrap" [ngClass]="!documentsValid && !documentsForm.get('orelap').value ? 'text-red-400' : ''">
                                ORELAP Accreditation</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="premisesSketch">
                              <span class="text-wrap"
                                [ngClass]="!documentsValid && !documentsForm.get('premisesSketch').value ? 'text-red-400' : ''">
                                Premises Plan Including Boundaries, and Camera Plan
                              </span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="premisePicture">
                              <span class="text-wrap" [ngClass]="!documentsValid && !documentsForm.get('premisePicture').value ? 'text-red-400' : ''">
                                Proposed Premises Pictures
                              </span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="updatedPremisePicture">
                              <span class="text-wrap">Updated premise pictures</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="socialEquityPlan">
                              <span class="text-wrap"
                                [ngClass]="!documentsValid && !documentsForm.get('socialEquityPlan').value ? 'text-red-400' : ''">
                                Social Equity Plan
                              </span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="updatedEquityPlan">
                              <span class="text-wrap">Updated Social Equity Plan</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="equityPlanEvaluation">
                              <span class="text-wrap">Social Equity Plan Evaluation</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="physical">
                              <span class="text-wrap">Physical Application</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="gisReview">
                              <span class="text-wrap">Gis Review</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="interviewDocumentation">
                              <span class="text-wrap">Interview Documentation</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="siteInspectionFollowUp">
                              <span class="text-wrap">Site Inspection Follow Up</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="caseDocumentation">
                              <span class="text-wrap">Case Documentation</span>
                            </mat-checkbox>

                            <mat-checkbox formControlName="other">
                              <span class="text-wrap">Other</span>
                            </mat-checkbox>

                          </div>

                          <input type="file" class="file-input" (change)="uploadLicenseDocument($event)" #fileUpload />
                          <div class="flex flex-row gap-2">
                            <div class="file-upload">
                              <button [disabled]="!documentsForm.get('orelap').value &&
                                                  !documentsForm.get('premisesSketch').value &&
                                                  !documentsForm.get('socialEquityPlan').value &&
                                                  !documentsForm.get('other').value &&
                                                  !documentsForm.get('physical').value &&
                                                  !documentsForm.get('gisReview').value &&
                                                  !documentsForm.get('gisReview').value &&
                                                  !documentsForm.get('interviewDocumentation').value &&
                                                  !documentsForm.get('siteInspectionFollowUp').value &&
                                                  !documentsForm.get('caseDocumentation').value &&
                                                  !documentsForm.get('premisePicture').value &&
                                                  !documentsForm.get('updatedEquityPlan').value &&
                                                  !documentsForm.get('equityPlanEvaluation').value &&
                                                  !documentsForm.get('updatedPremisePicture').value"
                                        mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                                Browse
                                <mat-icon>attach_file</mat-icon>
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </mat-card-content>
              </mat-card>

              <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[50%]">
                <mat-card-title>
                  <span>Current Documents</span>
                </mat-card-title>
                <mat-card-content>
                  <mat-card>
                    <mat-card-content>
                      <div class="flex flex-col">
                        <div *ngIf="!sharedService.mobile" class="flex flex-row">
                          <span class="f-s-16 w-[35%]"><strong>File</strong></span>
                          <span class="f-s-16 w-[20%]"><strong>Requirement</strong></span>
                          <span class="f-s-16 w-[20%]"><strong>Date Uploaded</strong></span>
                          <span class="f-s-16 w-[10%]"><strong>Archive</strong></span>
                        </div>

                        <div *ngFor="let document of this.license.licenseDocuments" class="max-md:flex-col flex flex-row justify-start items-start">
                          <ng-container *ngIf="!document.deprecated">
                            <span class="text-indigo-A700 w-[35%]" style="cursor: pointer; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="document.name" matTooltipShowDelay="500" (click)="downloadDocument(document.id, document.name)">{{document.name}}</span>

                            <div class="flex flex-col w-[20%]">
                              <span *ngFor="let type of document.types">
                                {{documentTypeReference[type]}}
                              </span>
                            </div>

                            <span class="w-[20%]">{{document.dateCreated | date}}</span>

                            <button [hidden]="!editingLicense || (!authService.isAdmin && !authService.isTestingLabAdmin)" mat-icon-button color="warn" aria-label="Archive Document" (click)="deprecateDocument(document.id)" class="w-[10%]">
                              <mat-icon>archive</mat-icon>
                            </button>
                          </ng-container>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>

                  <div class="flex flex-row">
                    <button type="button" color="primary" mat-flat-button (click)="viewArchivedDocuments()">
                      <span *ngIf="!viewArchived">
                        View Archived Documents
                      </span>
                      <span *ngIf="viewArchived">
                        Hide Archived Documents
                      </span>
                    </button>
                  </div>

                  <br />
                  <mat-card-title *ngIf="viewArchived">
                    <span>Archived Documents</span>
                  </mat-card-title>
                  <mat-card *ngIf="viewArchived" [style.background]="'#c7cdd1'">
                    <mat-card-content>
                      <div class="flex flex-col">
                        <div *ngIf="!sharedService.mobile" class="flex flex-row">
                          <span class="f-s-16 max-lg:w-[35%] w-[30%]"><strong>File</strong></span>
                          <span class="f-s-16 w-[20%]"><strong>Requirement</strong></span>
                          <span class="f-s-16 w-[20%]"><strong>Date Uploaded</strong></span>
                          <span class="f-s-16 w-[10%]"><strong>Unarchive</strong></span>
                        </div>
                        <div *ngFor="let document of this.license.licenseDocuments" style="justify-content: center;" class="max-md:flex-col flex flex-row justify-start items-start">
                          <ng-container *ngIf="document.deprecated">
                            <span class="text-indigo-A700 max-lg:w-[35%] w-[30%]" style="cursor: pointer; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="document.name" matTooltipShowDelay="500" (click)="downloadDocument(document.id, document.name)">{{document.name}}</span>

                            <div class="flex flex-col w-[20%]">
                              <span *ngFor="let type of document.types">
                                {{documentTypeReference[type]}}
                              </span>
                            </div>

                            <span class="w-[20%]">{{document.dateCreated | date}}</span>

                            <button [hidden]="!editingLicense || !authService.isAdmin" mat-icon-button color="primary" aria-label="Archive Document" (click)="deprecateDocument(document.id)" class="w-[10%]">
                              <mat-icon>unarchive</mat-icon>
                            </button>

                            <span class="flex-1"></span>

                            <button *ngIf="editingLicense && authService.isAdmin" type="button" mat-icon-button class="m-8 justify-start items-end w-[10%]" (click)="deleteDocument(document.id, document.name)" color="warn" aria-label="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                          </ng-container>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </mat-card-content>
              </mat-card>
            </div>
          </form>

          <!--Applicants-->
          <div class="max-md:flex-col flex flex-row gap-2">
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" [ngStyle]="{'display': !editingEntityApplicant? '' : 'none'}" [ngClass]="editingApplicant ? 'w-[100%]' : 'w-[50%]'">
              <mat-card-content class="gap-2">
                <app-applicant [applicationDate]="license.applicationDate" [licenseId]="license.id" [licenseType]="sharedService.testingLab" [primaryContactId]="license.primaryContactId" [documentTypes]="documentTypes" tableColor="orange" [renewal]="license.isRenewal" (notifyDeduplicate)="deduplicateApplicant($event)" (notifyParent)="editApplicant($event)" (notifyUpdate)="updateApplicant($event)" (notifyDelete)="deleteApplicant($event)" (setPointOfContact)="setPointOfContact($event)" [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" [editingLicense]="editingLicense" [renewalChanges]="changedFields" [admin]="authService.isTestingLabAdmin" [licenseLocked]="licenseLocked" class="max-md:w-[100%]">
                </app-applicant>

                <div style="cursor: pointer;" *ngIf="!dedeuplicating" class="max-md:flex-col flex flex-row gap-2">
                  <button type="button" color="primary" mat-flat-button (click)="openContactInformationChangeLog()">
                    <span>
                      Contact Information History
                    </span>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" *ngIf="!editingApplicant" [ngClass]="editingEntityApplicant ? 'w-[100%]' : 'w-[50%]'">
              <mat-card-content>
                <app-entity-applicant [licenseId]="license.id" [licenseType]="sharedService.testingLab" tableColor="orange" [renewal]="license.isRenewal" [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" [documentTypes]="documentTypes" [editingLicense]="editingLicense" [individualApplicants]="individualApplicants?.applicants" (notifyParent)="editEntityApplicant($event)" [renewalChanges]="changedFields" [admin]="authService.isTestingLabAdmin" [licenseLocked]="licenseLocked" class="max-md:w-[100%]">
                </app-entity-applicant>
              </mat-card-content>
            </mat-card>
          </div>

          <!--Payments-->
          <app-manage-payments *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut]
                               [entityId]="license.id.toString()"
                               [entityType]="paymentService.TestingLabPaymentOption"
                               [allowMultiplePayments]='true'
                               [editingPayment]="editingLicense"
                               (notifyParent)="paymentUpdated($event)"
                               [allowDelete]='authService.isAdmin'
                               [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor"
                               [renewal]="license.isRenewal">
          </app-manage-payments>

          <!--Notes-->
          <app-manage-notes *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut]
                            [entityId]="license.id.toString()"
                            [entityType]="sharedService.testingLab"
                            [editingNotes]="editingLicense"
                            [licenseId]="license.licenseId"
                            [renewalNumber]="getRenewalNumber(license)"
                            [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor">
          </app-manage-notes>

          <app-manager-alerts *ngIf="shouldShowManagerAlerts"
                             [isAdmin]="authService.isAdmin"
                             [data]="{alerts: license.managerAlerts, entityId: license.id, entityType: sharedService.testingLabEntityType}"
                             [isEditing]="editingLicense"
                             [canTransferAlerts]="canTransferAlerts() && (authService.isAdmin || authService.isTestingLabAdmin)"
                             [isTransferAlertsDisabled]=" !license || license.alertsTransferred"
                             (transferAlertsRequested)="handleTransferAlerts($event, license.id)"
                             [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor"
                             (notifyParent)="managerAlertsUpdated($event)">
          </app-manager-alerts>

          <!--Worker Pemits-->
          <app-associated-worker-permits *ngIf="!editingApplicant && !editingEntityApplicant" [licenseType]="sharedService.testingLab" (removePTSPermit)="removePTSPermit($event)" [isAdmin]="authService.isAdmin || authService.isServiceCenterAdmin"
            (addPermit)="addPermit($event)" [id]="license.id" [permits]="license.workerPermits" [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor">
          </app-associated-worker-permits>

          <div *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut] class="max-lg:flex-col flex flex-row gap-2">
            <!--Tasks-->
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[100%]">
              <mat-card-title>
                Tasks
              </mat-card-title>
              <mat-card-content>
                <mat-table [dataSource]="taskSource" aria-describedby="tasks" class="mat-elevation-z8 m-b-0">

                  <ng-container matColumnDef="task">
                    <mat-header-cell *matHeaderCellDef>Task</mat-header-cell>
                    <mat-cell *matCellDef="let task">
                      <span class="mobile-label">Task</span>
                      {{task.taskText}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef="">Actions</mat-header-cell>
                    <mat-cell *matCellDef="let task">
                      <div class="flex flex-row justify-start items-center gap-6">
                        <div class="flex flex-col gap-2">
                          <button *ngIf="task.sendNotice" mat-flat-button color="primary" style="line-height: normal" (click)="sendTaskNotice(task)">
                            <span class="text-wrap">{{task.taskText}}</span>
                          </button>
                          <button *ngIf="task.acknowledge" mat-flat-button color="primary" (click)="acknowledgeTask(task.id)">
                            Acknowledge
                          </button>
                        </div>
                        <button *ngIf="task.id !== 0 && (authService.isTestingLabAdmin || authService.isAdmin)" mat-icon-button color="warn" aria-label="Delete Task"
                          (click)="deleteTask(task)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="taskColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: taskColumns"></mat-row>
                </mat-table>
              </mat-card-content>
            </mat-card>
          </div>

          <div *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut] class="max-lg:flex-col flex flex-row gap-2">
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[40%]">
              <mat-card-title>
                <span>Electronic Signature</span>
              </mat-card-title>
              <mat-card-content>
                <form [formGroup]="licenseForm">
                  <div class="max-md:gap-6 flex flex-col gap-[33px]">
                    <mat-checkbox *ngIf="editingLicense" formControlName="attestation" [ngClass]="{'disable-pointer-events': !authService.isAdmin && !authService.isTestingLabAdmin}">
                      Applicant attests that the information is accurate.
                    </mat-checkbox>

                    <div *ngIf="!editingLicense" class="flex flex-row justify-start items-center gap-2">
                      <mat-icon>{{license.attestation? "check_box" : "check_box_outline_blank"}}</mat-icon>
                      <span>Applicant attests that the information is accurate.</span>
                    </div>

                    <mat-form-field>
                      <input matInput placeholder="Signature" formControlName="electronicSignature">
                    </mat-form-field>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>

            <!--Complete-->
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[60%]">
              <mat-card-title>
                Complete Testing Lab
              </mat-card-title>
              <mat-card-content>
                <mat-card>
                  <mat-card-content>
                    <div class="flex flex-col gap-4">
                      <div style="font-size:large" class="flex flex-row gap-2">
                        <span class="f-s-18 m-b-8" *ngIf="licenseForm.get('licenseExpiredBeforeRenewal').value && !editingLicense">License Expired Before Renewal</span>
                        <form [formGroup]="licenseForm" *ngIf="editingLicense">
                          <mat-checkbox formControlName="licenseExpiredBeforeRenewal" [disabled]="!authService.isAdmin && !authService.isTestingLabAdmin">
                            License Expired Before Renewal
                          </mat-checkbox>
                        </form>
                      </div>
                      <div style="font-size:large" *ngIf="license.requestWithdrawDate != null && license.requestWithdrawDate != ''" class="flex flex-row gap-2">
                        <span><strong>Requested Withdraw On</strong></span>
                        <span>{{license.requestWithdrawDate | date}}</span>
                      </div>
                      <div style="font-size:large" *ngIf="license.approveWithdrawDate != null && license.approveWithdrawDate != ''" class="flex flex-row gap-2">
                        <span><strong>Approved Withdraw On</strong></span>
                        <span>{{license.approveWithdrawDate | date}}</span>
                      </div>
                      <div style="font-size:large" *ngIf="license.denyWithdrawDate != null && license.denyWithdrawDate != ''" class="flex flex-row gap-2">
                        <span><strong>Denied Withdraw On</strong></span>
                        <span>{{license.denyWithdrawDate | date}}</span>
                      </div>

                        <div style="font-size:large" *ngIf="license.requestSurrenderDate != null && license.requestSurrenderDate != ''" class="flex flex-row gap-2">
                          <span><strong>Requested Surrender On</strong></span>
                          <span>{{license.requestSurrenderDate | date}}</span>
                        </div>
                        <div style="font-size:large" *ngIf="license.approveSurrenderDate != null && license.approveSurrenderDate != ''" class="flex flex-row gap-2">
                          <span><strong>Approved Surrender On</strong></span>
                          <span>{{license.approveSurrenderDate | date}}</span>
                        </div>
                        <div style="font-size:large" *ngIf="license.denySurrenderDate != null && license.denySurrenderDate != ''" class="flex flex-row gap-2">
                          <span><strong>Denied Surrender On</strong></span>
                          <span>{{license.denySurrenderDate | date}}</span>
                        </div>

                      <div style="font-size:large" class="flex flex-row gap-2">
                        <span><strong>Current Status</strong></span>
                        <div class="flex flex-row gap-2">
                          <span>{{license.status}}</span>
                          <span *ngIf="license.isRenewal">Renewal</span>
                        </div>
                      </div>
                      <div style="font-size:large" class="flex flex-row gap-2">
                        <span><strong>Submitted On</strong></span>
                        <span>{{license.applicationDate | date}}</span>
                      </div>
                      <div style="font-size:large" class="flex flex-row gap-2" *ngIf="license.approvedPendingFeeDate && license.status == sharedService.awaitingPayment">
                        <span><strong>Approved, Pending Payment and Clearance Date</strong></span>
                        <span>{{license.approvedPendingFeeDate | date:'MMM d, yyyy'}}</span>
                      </div>
                      <div style="font-size:large" class="flex flex-row gap-2" *ngIf="dateOfClosure && license.status == sharedService.awaitingPayment">
                        <span><strong>Date of Auto-Closure Due to Non-Payment</strong></span>
                        <span>{{dateOfClosure | date:'MMM d, yyyy'}}</span>
                      </div>
                        <div style="font-size:large" *ngIf="license.isRenewal && !editingLicense" class="flex flex-row gap-2">
                          <span *ngIf="!license.isRenewal"><strong>Approved Date</strong></span>
                          <span *ngIf="license.isRenewal"><strong>Renewed Date</strong></span>
                          <span>{{license.approvedDate | date}}</span>
                        </div>
                        <div style="font-size:large" *ngIf="license.isRenewal && editingLicense && authService.isAdmin && licenseForm.get('status').value == 'Approved'" class="flex flex-row gap-2">
                          <mat-form-field [formGroup]="licenseForm" class="w-[50%]">
                            <mat-label *ngIf="!license.isRenewal">Approved Date</mat-label>
                            <mat-label *ngIf="license.isRenewal">Renewed Date</mat-label>
                            <input placeholder="mm/dd/yyyy" formControlName="approvedDate" matInput [matDatepicker]="approvedDate"/>
                            <mat-datepicker-toggle matSuffix [for]="approvedDate"></mat-datepicker-toggle>
                            <mat-datepicker #approvedDate>
                              <mat-datepicker-actions>
                                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                                <button mat-button matDatepickerCancel>Cancel</button>
                              </mat-datepicker-actions>
                            </mat-datepicker>
                          </mat-form-field>
                          <div class="flex flex-col gap-2 w-[50%]">
                          <span><i>*<strong>For Timely Renewals & Untimely Renewals renewed BEFORE expiration</strong>: Enter date after current expiration date.</i></span>
                          <span><i>*<strong>For Untimely Renewals renewed AFTER expiration</strong>: Enter date that staff marked the renewal as approved.</i></span>
                          <span style="padding-left: 20px;"><i>*The date entered here calculates the new expiration date.</i></span>
                          </div>
                        </div>
                        <div style="font-size:large" *ngIf="license.isRenewal && !editingLicense" class="flex flex-row gap-2">
                          <span><strong>Date Renewal Approved</strong></span>
                          <span>{{license.renewedDate | date}}</span>
                        </div>
                        <div style="font-size:large" *ngIf="license.isRenewal && editingLicense && licenseForm.get('status').value == 'Approved'" class="flex flex-row gap-2">
                          <mat-form-field [formGroup]="licenseForm" class="w-[50%]">
                            <mat-label>Date Renewal Approved</mat-label>
                            <input placeholder="mm/dd/yyyy" formControlName="renewedDate" matInput [matDatepicker]="renewedDate"/>
                            <mat-datepicker-toggle matSuffix [for]="renewedDate"></mat-datepicker-toggle>
                            <mat-datepicker #renewedDate>
                              <mat-datepicker-actions>
                                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                                <button mat-button matDatepickerCancel>Cancel</button>
                              </mat-datepicker-actions>
                            </mat-datepicker>
                          </mat-form-field>
                          <div class="flex flex-col justify-center items-center gap-2 w-[50%]">
                            <span><i>*Enter date that staff marked the renewal as approved.</i></span>
                            <span style="padding-left: 20px;"><i>*This date shows up on public side.</i></span>
                          </div>
                        </div>
                        <div style="font-size:large" *ngIf="!editingLicense && licenseForm.get('status').value == 'Closed'" class="flex flex-row gap-2">
                          <span><strong>Closed Date</strong></span>
                          <span>{{license.closedDate | date}}</span>
                        </div>
                        <div style="font-size:large" *ngIf="editingLicense && licenseForm.get('status').value == 'Closed'" class="flex flex-row gap-2">
                          <mat-form-field [formGroup]="licenseForm" class="w-[50%]">
                            <mat-label>Closed Date</mat-label>
                            <input placeholder="mm/dd/yyyy" formControlName="closedDate" matInput [matDatepicker]="closedDate"/>
                            <mat-datepicker-toggle matSuffix [for]="closedDate"></mat-datepicker-toggle>
                            <mat-datepicker #closedDate>
                              <mat-datepicker-actions>
                                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                                <button mat-button matDatepickerCancel>Cancel</button>
                              </mat-datepicker-actions>
                            </mat-datepicker>
                          </mat-form-field>
                        </div>
                        <div *ngIf="license.status == sharedService.requestSurrender" class="flex gap-2 lg:flex-row flex-col w-1/2">
                          <button mat-flat-button type="button" color="primary" (click)="surrenderLicense(true, license.id)" *ngIf="authService.isTestingLabAdmin">
                             Approve Surrender Request
                          </button>
                          <button  mat-flat-button type="button" color="warn" (click)="surrenderLicense(false, license.id)" *ngIf="authService.isTestingLabAdmin">
                            Deny Surrender Request
                          </button>
                          <button mat-flat-button type="button" color="warn" (click)="cancelSurrender(license.id)">
                            Cancel Surrender Request
                          </button>
                        </div>

                        <div *ngIf="license.status == sharedService.requestWithdraw && authService.isTestingLabAdmin" class="max-md:flex-col flex flex-row justify-start items-start gap-6">
                          <button mat-flat-button type="button" color="primary" (click)="withdrawLicense(true, license.id)">
                             Approve Withdraw Request
                        </button>
                        <button  mat-flat-button type="button" color="warn" (click)="withdrawLicense(false, license.id)">
                          Deny Withdraw Request
                      </button>
                        </div>

                      <span *ngIf="license.status != sharedService.requestWithdraw && license.status != sharedService.requestSurrender"><strong>Update Status</strong></span>
                      <div [hidden]="authService.isTestingLabAdmin || license.status == sharedService.requestWithdraw || license.status == sharedService.requestSurrender || license.status == sharedService.revoked || license.status == sharedService.pendingRevocation || license.status == sharedService.denied
                      || license.status == sharedService.pendingDenial || license.status == sharedService.approved || license.status == sharedService.awaitingPayment || license.status == sharedService.withdrawn || license.status == sharedService.closed" class="flex flex-row w-[100%]">
                        <mat-form-field [formGroup]="licenseForm" [hidden]="licenseLocked" class="w-[100%]">
                          <mat-label>
                            Status
                          </mat-label>
                          <mat-select formControlName="status" class="w-[100%]">
                            <mat-option *ngIf="license.isRenewal"[value]="sharedService.renewalSubmitted">Renewal Submitted/For Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && !license.isRenewal" [value]="sharedService.underReview">Under Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && !license.isRenewal && showPeerReview()" [value]="sharedService.peerReview">Ready For Peer Review</mat-option>
                            <mat-option *ngIf="license.isRenewal && showPeerReview()" [value]="sharedService.renewalPeerReview">Renewal Ready for Peer Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && validateBackgroundCheckCompleted() && !license.isRenewal" [value]="sharedService.submittedForApproval">Submitted for Approval</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && validateBackgroundCheckCompleted() && license.isRenewal" [value]="sharedService.renewalSubmittedForApproval">Renewal Submitted for Approval</mat-option>
                            <mat-option *ngIf="hasPaidApplicationFee && !license.isRenewal" [value]="sharedService.awaitingPayment">Approved, Pending Payment and Clearance</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && !license.isRenewal" [value]="sharedService.incomplete">Incomplete</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && !license.isRenewal" [value]="sharedService.insufficient">Insufficient</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && !license.isRenewal" [value]="sharedService.readyForLicensingManagerReview">Ready for Licensing Manager Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && !license.isRenewal" [value]="sharedService.readyForComplianceManagerReview">Ready for Compliance Manager Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && !license.isRenewal" [value]="sharedService.siteInspectionComplete">Site Inspection Complete, Awaiting Follow Up</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && license.isRenewal" [value]="sharedService.renewalReadyForLicensingManagerReview">Renewal Ready for Licensing Manager Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && license.isRenewal" [value]="sharedService.renewalReadyForComplianceManagerReview">Renewal Ready for Compliance Manager Review</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && license.isRenewal" [value]="sharedService.renewalSubmittedForApprovalForLicensingManager">Renewal Submitted for Approval for Licensing Manager</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved && validateChecklist() && license.isRenewal" [value]="sharedService.renewalSiteInspectionComplete">Renewal Site Inspection Complete, Awaiting Follow Up</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved" [value]="sharedService.submitForClosure">Submit For Closure</mat-option>
                            <mat-option *ngIf="license.status != sharedService.approved" [value]="sharedService.pendingDenial">Pending Denial</mat-option>
                            <mat-option *ngIf="license.status == sharedService.approved" [value]="sharedService.pendingRevocation">Pending Revocation</mat-option>
                            <mat-option *ngIf="license.status == sharedService.approved" [value]="sharedService.expired">Expired</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div [hidden]="!authService.isTestingLabAdmin ||license.status == sharedService.requestWithdraw || license.status == sharedService.requestSurrender" class="flex flex-row w-[100%]">
                        <mat-form-field [formGroup]="licenseForm" [hidden]="licenseLocked" class="w-[100%]">
                          <mat-label>
                            Status
                          </mat-label>
                          <mat-select formControlName="status" class="w-[100%]">
                            <mat-option  *ngIf="!license.isRenewal" [value]="sharedService.submitted">Submitted</mat-option>
                            <mat-option  *ngIf="!license.isRenewal" [value]="sharedService.pending">Pending</mat-option>
                            <mat-option  *ngIf="!license.isRenewal" [value]="sharedService.underReview">Under Review</mat-option>
                            <mat-option  *ngIf="!license.isRenewal && showPeerReview()" [value]="sharedService.peerReview">Ready For Peer Review</mat-option>
                            <mat-option  *ngIf="license.isRenewal && showPeerReview()" [value]="sharedService.renewalPeerReview">Renewal Ready for Peer Review</mat-option>
                            <mat-option  *ngIf="license.isRenewal && authService.isAdmin" [value]="sharedService.pendingRenewal">Pending Renewal</mat-option>
                            <mat-option  *ngIf="license.isRenewal" [value]="sharedService.renewalSubmitted">Renewal Submitted/For Review</mat-option>
                            <mat-option  *ngIf="license.isRenewal" [value]="sharedService.renewalReviewTimely">Renewal Under Review/Timely</mat-option>
                            <mat-option  *ngIf="license.isRenewal" [value]="sharedService.renewalReviewUntimely">Renewal Under Review/Untimely</mat-option>
                            <mat-option  *ngIf="authService.isAdmin && license.isRenewal" [value]="sharedService.renewalApprovedPendingPaymentandClearance">Renewal Approved, Pending Fee Payment and Clearance</mat-option>
                            <mat-option  *ngIf="authService.isAdmin" [value]="sharedService.renewed">Renewed</mat-option>
                            <mat-option  *ngIf="validateChecklist() && validateBackgroundCheckCompleted() && !license.isRenewal" [value]="sharedService.submittedForApproval">Submitted for Approval</mat-option>
                            <mat-option  *ngIf="validateChecklist() && validateBackgroundCheckCompleted() && license.isRenewal" [value]="sharedService.renewalSubmittedForApproval">Renewal Submitted for Approval</mat-option>
                            <mat-option  *ngIf="!license.isRenewal" [value]="sharedService.incomplete">Incomplete</mat-option>
                            <mat-option  *ngIf="!license.isRenewal" [value]="sharedService.insufficient">Insufficient</mat-option>
                            <mat-option  *ngIf="validateChecklist() && !license.isRenewal" [value]="sharedService.readyForLicensingManagerReview">Ready for Licensing Manager Review</mat-option>
                            <mat-option  *ngIf="validateChecklist() && !license.isRenewal" [value]="sharedService.readyForComplianceAssignmentAndInspection">Ready for Compliance Assignment and Inspection</mat-option>
                            <mat-option  *ngIf="validateChecklist() && !license.isRenewal" [value]="sharedService.readyForComplianceManagerReview">Ready for Compliance Manager Review</mat-option>
                            <mat-option  *ngIf="validateChecklist() && !license.isRenewal" [value]="sharedService.siteInspectionComplete">Site Inspection Complete, Awaiting Follow Up</mat-option>
                            <mat-option  *ngIf="validateChecklist() && license.isRenewal" [value]="sharedService.renewalReadyForLicensingManagerReview">Renewal Ready for Licensing Manager Review</mat-option>
                            <mat-option  *ngIf="validateChecklist() && license.isRenewal" [value]="sharedService.renewalReadyForComplianceAssignmentAndInspection">Renewal Ready for Compliance Assignment and Inspection</mat-option>
                            <mat-option  *ngIf="validateChecklist() && license.isRenewal" [value]="sharedService.renewalReadyForComplianceManagerReview">Renewal Ready for Compliance Manager Review</mat-option>
                            <mat-option  *ngIf="validateChecklist() && license.isRenewal" [value]="sharedService.renewalSubmittedForApprovalForLicensingManager">Renewal Submitted for Approval for Licensing Manager</mat-option>
                            <mat-option  *ngIf="validateChecklist() && license.isRenewal" [value]="sharedService.renewalSiteInspectionComplete">Renewal Site Inspection Complete, Awaiting Follow Up</mat-option>
                            <mat-option  [value]="sharedService.closed">Closed</mat-option>
                            <mat-option  [value]="sharedService.withdrawn">Withdrawn</mat-option>
                            <mat-option  *ngIf="hasPaidApplicationFee && !license.isRenewal" [value]="sharedService.awaitingPayment">Approved, Pending Payment and Clearance</mat-option>
                            <mat-option  *ngIf="licensePaid && validateChecklist() && validateBackgroundCheckCompleted()"  [value]="sharedService.approved">Approved</mat-option>
                            <mat-option  [value]="sharedService.submitForClosure">Submit For Closure</mat-option>
                            <mat-option  [value]="sharedService.pendingDenial">Pending Denial</mat-option>
                            <mat-option  [value]="sharedService.denied">Denied</mat-option>
                            <mat-option  [value]="sharedService.surrendered">Surrendered</mat-option>
                            <mat-option  *ngIf="license.status == sharedService.approved" [value]="sharedService.pendingRevocation">Pending Revocation</mat-option>
                            <mat-option  [value]="sharedService.revoked">Revoked</mat-option>
                            <mat-option  [value]="sharedService.expired">Expired</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div *ngIf="!validateBackgroundCheckCompleted()" class="flex flex-row w-[100%]">
                        <span style="color: red"><em>License missing passing background check or background check completed date</em></span>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </mat-card-content>
              <button type="button" color="primary" mat-flat-button *ngIf="canTransfer() && !license.isRenewal && (authService.isAdmin || authService.isTestingLabAdmin)" (click)="transferPTS(license.id)" [disabled]="license.ptsTransferred">
                <span>Transfer PTS Items</span>
              </button>
            </mat-card>
          </div>

          <div *ngIf="!dedeuplicating && !editingApplicant && !editingEntityApplicant" class="max-lg:flex-col flex flex-row gap-2">
            <!--Previous Licenses-->
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" class="max-lg:w-[100%] w-[50%]">
              <mat-card-title>
                Historical Licenses
              </mat-card-title>
              <mat-card-content class="gap-2">
                <div class="flex flex-col gap-2">
                <mat-table [dataSource]="expiredLicensesSource" matSort aria-describedby="expiredLicenses" #expiredLicensesSort="matSort" class="mat-elevation-z8 m-b-0">

                  <ng-container matColumnDef="licenseId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>License ID</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">License ID</span>
                      {{license.licenseId}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="applicationDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Submitted Date</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">Submitted Date</span>
                      {{license.applicationDate | date}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="approvedDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Approved/Renewed Date</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">Approved Date</span>
                      {{license.approvedDate | date}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="expirationDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">Expiration Date</span>
                      {{license.expirationDate | date}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">Status</span>
                      {{license.status}}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="renewalNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Renewal Number</mat-header-cell>
                    <mat-cell *matCellDef="let license" [routerLink]="['/testing-lab/assigned', license.id]">
                      <span class="mobile-label">Renewal Number</span>
                        {{getRenewalNumber(license)}}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="expiredLicensesColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: expiredLicensesColumns" ngClass="hasRenewal" [ngClass]="{'hasRenewal': row.hasRenewal, 'isRenewal': row.isRenewal && !row.hasRenewal && !row.renewed && row.status != sharedService.expired && row.status != sharedService.approved}"></mat-row>
                </mat-table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25]" #expiredLicensesPaginator="matPaginator">
                </mat-paginator>
              </div>
              </mat-card-content>
            </mat-card>

            <!--Renewals-->
            <mat-card [style.background]="license.isRenewal && !license.hasRenewal && !license.renewed && license.status != sharedService.approved? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor" *ngIf="license.canRenew || license.isRenewal" class="max-lg:w-[100%] flex flex-col gap-5 w-[50%]">
              <div class="flex flex-row">
                <mat-card-title>
                  Renewal Currently Under Review
                </mat-card-title>
                <span class="flex-1"></span>
                <span>
                  <span (click)="createRenewal(license)" class="f-s-16" style="cursor: pointer;" *ngIf="license.canRenew && !hasRenewal && license.status == 'Approved' && (authService.isAdmin || authService.isTestingLabAdmin)">Add Renewal</span>
                  <button type="button" mat-icon-button color="primary" matTooltip="Add Renewal" matTooltipShowDelay=800
                    *ngIf="license.canRenew && !hasRenewal && license.status == 'Approved' && (authService.isAdmin || authService.isTestingLabAdmin)" aria-label="Add license" (click)="createRenewal(license)">
                    <mat-icon>post_add</mat-icon>
                  </button>
                </span>
              </div>

              <mat-card-content class="gap-2">
                <div class="flex flex-col gap-[10px]">
                  <div class="flex flex-row gap-4">
                    <div class="flex flex-col w-[33%]">
                      <span class="f-s-18 m-b-8" *ngIf="license.isRenewal && !editingLicense && licenseForm.get('timely').value">Timely Renewal</span>
                      <span class="f-s-18 m-b-8" *ngIf="license.isRenewal && !editingLicense && !licenseForm.get('timely').value">Untimely Renewal</span>
                        <form [formGroup]="licenseForm" *ngIf="editingLicense && license.isRenewal">
                          <mat-radio-group formControlName="timely" [disabled]="!authService.isAdmin" class="flex flex-col gap-[10px]">
                            <mat-radio-button [value]="true">Timely Renewal</mat-radio-button>
                            <mat-radio-button [value]="false">Untimely Renewal</mat-radio-button>
                          </mat-radio-group>
                        </form>
                    </div>

                    <span [ngClass]="canTransfer() ? 'w-[0%]' : 'w-[33%]'"></span>

                    <div class="flex flex-col w-[33%]">
                      <button type="button" color="primary" mat-flat-button (click)="openRenewalChangeLog()" *ngIf="license.isRenewal">
                        <span>
                         Updates On Renewal
                        </span>
                      </button>
                    </div>

                    <div [ngClass]="canTransfer() ? 'w-[33%]' : 'w-[0%]'" class="flex flex-col">
                      <button type="button" color="primary" mat-flat-button *ngIf="canTransfer() && (authService.isAdmin || authService.isTestingLabAdmin)" (click)="transferPTS(license.id)" [disabled]="license.ptsTransferred">
                        <span>Transfer PTS Items</span>
                      </button>
                    </div>
                  </div>
                  <div class="flex flex-row gap-4 flex-1">

                    <mat-table [dataSource]="[license]" class="flex-1">
                      <ng-container matColumnDef="licenseId">
                        <mat-header-cell *matHeaderCellDef>License ID</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">License ID</span>
                          {{license.licenseId}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="applicationDate">
                        <mat-header-cell *matHeaderCellDef>Submitted Date</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Submitted Date</span>
                          {{license.applicationDate | date}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="approvedDate">
                        <mat-header-cell *matHeaderCellDef>Approved Date</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Approved Date</span>
                          {{licenseForm.get('approvedDate').value | date}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="renewedDate">
                        <mat-header-cell *matHeaderCellDef>Date Renewal Approved</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Date Renewal Approved</span>
                          {{licenseForm.get('renewedDate').value | date}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="expirationDate">
                        <mat-header-cell *matHeaderCellDef>Expiration Date</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Expiration Date</span>
                          {{license.expirationDate | date}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Status</span>
                          {{license.status}}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="renewalNumber">
                        <mat-header-cell *matHeaderCellDef>Renewal Number</mat-header-cell>
                        <mat-cell *matCellDef="let license">
                          <span class="mobile-label">Renewal Number</span>
                          {{getRenewalNumber(license)}}
                        </mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="currentLicenseColumns"></mat-header-row>
                      <mat-row *matRowDef="let license; columns: currentLicenseColumns" [ngClass]="{'hasRenewal': license.hasRenewal, 'isRenewal': license.isRenewal && !license.hasRenewal && !license.renewed}"></mat-row>
                    </mat-table>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut] class="max-md:flex-col max-md:justify-start max-md:items-center flex flex-row gap-2">
            <div style="cursor: pointer;" class="max-md:flex-col flex flex-row gap-2">
              <span (click)="openChangeLog()">
                <mat-icon class="icon-20">history_edu</mat-icon> Change Log
              </span>
              <button  mat-button type="button" color="primary" (click)="openTaskHistory()">Task History</button>
              <button mat-button type="button" color="primary" (click)="exportLicense()">Export Original PDF</button>
              <button mat-button type="button" color="primary" *ngIf="license.status == 'Approved' && !isProduction && authService.isAdmin" (click)="updateExpirationDate()">Allow Renewal Start</button>
            </div>
            <span class="flex-1"></span>
            <button mat-button type="button" color="warn" (click)="cancelWorkingLicense()">Cancel</button>
            <button mat-button type="button" color="primary" *ngIf="(!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" (click)="updateLicense(false)" [hidden]="licenseLocked">Save</button>
            <button mat-button type="button" color="primary" *ngIf="(!license.hasRenewal || (license.hasRenewal && (authService.isAdmin || authService.isTestingLabAdmin)))" (click)="updateLicense(true)" [hidden]="licenseLocked">Save & Close</button>
          </div>
        </div>
      </div>
      <div [@slideInOut] [hidden]="!showChecklist" [ngClass]="showChecklist ? 'w-[25%]' : 'w-[0%]'" class="flex flex-row">
        <app-licenseChecklist
        [entityType]="sharedService.testingLab"
        [license]="license"
        [applicants]="individualApplicants != null? individualApplicants.applicants : license.applicants"
        (notifyParent)="updateChecklist($event)"
        [staff]="licenseStaff"
        [renewal]="license.isRenewal"
        [licenseLocked]="licenseLocked"
        >

        </app-licenseChecklist>
        </div>
      </div>
      </mat-card-content>
    </mat-card>
  </mat-tab>
  <mat-tab [label]="licenseLocked ? 'Site Inspections Locked' : 'Site Inspections'">
    <ng-template matTabContent>
      <app-site-inspection [entityId]="license.id"
                           [renewal]="license.isRenewal"
                           [licenseId]="license.licenseId"
                           [entityType]="sharedService.testingLab"
                           [entityName]="license.entityName"
                           [staff]="licenseStaff"
                           [notes]="notes.notes"
                           [cardColor]="license.isRenewal && !license.hasRenewal && !license.renewed? '#f9f093' : license.hasRenewal ? '#c7cdd1' : cardColor"
                           tableColor="orange"
                           [licenseLocked]="licenseLocked">
      </app-site-inspection>
    </ng-template>
  </mat-tab>
  <mat-tab [label]="licenseLocked ? 'Testing Lab Compliance Locked' : 'Testing Lab Compliance'">
    <ng-template matTabContent>
      <app-compliance [entityId]="license.id"
                      [renewal]="license.isRenewal"
                      [licenseId]="license.licenseId"
                      [entityReference]="license.licenseId"
                      [compliance]="compliance"
                      [entityType]="sharedService.testingLab"
                      [entityName]="license.entityName"
                      [notes]="notes.notes"
                      [staff]="licenseStaff"
                      [licenseLocked]="licenseLocked">
      </app-compliance>
    </ng-template>
  </mat-tab>
  <mat-tab [label]="licenseLocked ? 'Reported Events Locked' : 'Reported Events'">
    <ng-template matTabContent>
      <app-reported-event [entityId]="license.id"
                          [entityType]="sharedService.testingLab"
                          [reportedEvent]="reportedEvent"
                          [licenseLocked]="licenseLocked">
      </app-reported-event>
    </ng-template>
  </mat-tab>
</mat-tab-group>


<div *ngIf="licenseLoading">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>
